import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CallCenterService } from 'src/app/services/call-center.service';
import { AskApolloService } from 'src/app/services/ask-apollo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageServiceService } from 'src/app/services/message-service.service';
import { CalendarUtilityService } from 'src/app/services/calendar-utility.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HealthCheckService } from 'src/app/services/health-check.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonMethods } from 'src/app/shared/CommonMethods';
import { ItdoseService } from 'src/app/services/itdose.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-it-dose-appointment-history',
  templateUrl: './it-dose-appointment-history.component.html',
  styleUrls: ['./it-dose-appointment-history.component.scss']
})
export class ItDoseAppointmentHistoryComponent implements OnInit,OnDestroy {
  //popup
  displayPopup: boolean = false;
  isLoading: boolean = false;
  confirmModalRef: BsModalRef;
  @ViewChild('confirmTemplate', { static: false }) confirmTemplate: TemplateRef<any>;
  bookingHistoryModalRef: BsModalRef;
  @ViewChild('bookingHistoryTemplate', { static: false }) bookingHistoryTemplate: TemplateRef<any>;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }

  modalTitle;
  selectedApptDetails;
  isRescheduleApptOpen: boolean = false;
  isCancelApptPopupOpen: boolean = false;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  loadingFlag: boolean = false;
  callType;
  leadId;
  isNewUser;
  CallerStatusAutoId;
  tabItems: any;
  activeItem: any;
  patientName: string;
  patientEmail; string;
  patientMobile: string = "9493888651"; //9491898828, 9493888651
  patientUHIDMobile: string = "";
  patientUHID: any;
  showBasicDetailsTable: boolean = false;
  showAppointmentHistory: boolean = true;
  showCallHistory: boolean = false;
  showHCAppointmentHistory: boolean = false;
  showCorpHCAppointmentHistory: boolean = false;
  datesData: any[];
  slotsData: any;
  allSlotsData = [];
  slotsOnTime: any;
  isCancelConfirmed: boolean = true;
  rescheduleAppointmentForm: FormGroup;
  bookingStatusOnPreBookingData = [];
  selectedSlotDateForAppt: any;
  selectedCurrentState$ : Subscription;
  selectedViewHistory$ : Subscription;

  constructor(
    private callCenterService: CallCenterService,
    private hcService: HealthCheckService,
    private formBuilder: FormBuilder,
    private askApolloService: AskApolloService,
    private ITDoseService: ItdoseService,
    private messageService: MessageServiceService,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private calendarService: CalendarUtilityService,
    private router: Router,
  ) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log('prev:', event.url);
      });
    //this method get the selected uhid data from service
    this.selectedViewHistory$ = this.callCenterService.selectedViewHistory.subscribe(value => {
      console.log('i am view history:', value);
      this.showBasicDetailsTable = true;
      this.leadId = value.leadId;
      this.callType = value.callType;
      this.CallerStatusAutoId = value.CallerStatusAutoId;
      this.patientEmail = value.PatientDetails ? value.PatientDetails["emailId"] : "";
      this.patientMobile = value ? value.CallerMobileNumber : "";
      this.patientUHIDMobile = value ? value.UHIDMobileNumber : "";
      this.patientName = value.PatientDetails ? value.PatientDetails["firstName"] + " " + value.PatientDetails["lastName"] : "";
      this.patientUHID = value.PatientDetails ? value.PatientDetails["uhidNumber"] : "";
      this.getAppointmentsHistoryOnUHID();
    });
    //this method get the status of operation done in any child tab like appt book, call status updating, reschedule etc.
    this.selectedCurrentState$ = this.callCenterService.selectedCurrentState.subscribe(value => {
      if (value && value.isOperationDone) {
        this.getAppointmentsHistoryOnUHID();
      }
    });

  }

  ngOnInit() {
    this.maxDate.setDate(this.maxDate.getDate() + 3);

    this.rescheduleAppointmentForm = this.formBuilder.group({
      appointmentDate: ['', Validators.required],
      appointmentSlot: ['', [Validators.required, Validators.min(1)]],
      statusRemarks: ['']
    });

  }

  ngOnDestroy(): void {
    this.selectedCurrentState$.unsubscribe();
    this.selectedViewHistory$.unsubscribe();
  }

  CurrentappointmentsHistory = [];
  pastAppointmentHistory = [];
  appointmentHistory: any;
  cancelRescheduleBtnHide: boolean = false;
  getAppointmentsHistoryOnUHID() {
    let dd = new Date();
    let date = dd.getDate() + "";
    let month = (dd.getMonth() + 1) + "";
    let year = dd.getFullYear();
    let TodayDate = year + '-' + (month.length == 1 ? '0' + month : month) + '-' + (date.length == 1 ? '0' + date : date);
    this.CurrentappointmentsHistory = [];
    this.pastAppointmentHistory = [];
    this.loadingFlag = true;
    this.ITDoseService.getAppointmentBookingHistory("", this.patientUHIDMobile).subscribe((res: any) => {
      if (res && res.response && res.response.length > 0) {
        this.appointmentHistory = res.response;
        this.CurrentappointmentsHistory = this.appointmentHistory.filter(d => {
          if (d.slotDate >= TodayDate) {
            return true;
          }
        })
        this.pastAppointmentHistory = this.appointmentHistory.filter(d => {
          if (d.slotDate <= TodayDate) {
            return true;
          }
        })
      }
      else {
        this.CurrentappointmentsHistory = [];
        this.pastAppointmentHistory = [];
      }
      this.loadingFlag = false;
    }, error => {
      this.loadingFlag = false;
      this.messageService.showErrorMessage("Unable to retrieve appointment history data from server");
    })
  }

  showModalDialog(apptDetails, type) {
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-lg modal-dialog-centered' }));
    let callStatusObj;
    this.selectedApptDetails = apptDetails;
    if (type == "cancel") {
      callStatusObj = this.callType == 2 ? { callCenterStatusId: 23, statusName: "Cancel Appointment" } : { callCenterStatusId: 23, statusName: "Cancel Appointment" };
      this.modalTitle = "Cancel Appointment";
      this.statusRemarks = "";
      this.isCancelApptPopupOpen = true;
      this.isRescheduleApptOpen = false;
      this.callCenterService.ProceedToCancelAppt({
        "CallTypeId": this.callType,
        "CallStatus": callStatusObj,
        "LeadId": this.leadId,
        "IsNewUser": this.isNewUser,
        "CallerStatusAutoId": this.CallerStatusAutoId,
        "RescheduleDetails": this.selectedApptDetails
      });
    } else {
      callStatusObj = this.callType == 2 ? { callCenterStatusId: 16, statusName: "Rescheduling" } : { callCenterStatusId: 16, statusName: "Rescheduling" };
      this.modalTitle = "Reschedule Appointment";
      this.rescheduleAppointmentForm.get('statusRemarks').setValue('');
      this.rescheduleAppointmentForm.get('appointmentDate').setValue('');
      this.rescheduleAppointmentForm.get('appointmentSlot').setValue('');
      this.isRescheduleApptOpen = true;
      this.isCancelApptPopupOpen = false;
      this.callCenterService.ProceedToReschedule({
        "CallTypeId": this.callType,
        "CallStatus": callStatusObj,
        "LeadId": this.leadId,
        "IsNewUser": this.isNewUser,
        "CallerStatusAutoId": this.CallerStatusAutoId,
        "RescheduleDetails": this.selectedApptDetails
      });
    }

  }

  closeConfirmModal() {
    this.confirmModalRef.hide();
  }

  showBookingHistoryModalDialog(appt) {
    this.bookingStatusOnPreBookingData = [];
    this.loadingFlag = true;
    this.ITDoseService.getBookingStatusOnPreBookingId(appt.VisitNo).subscribe((res: any) => {
      this.bookingStatusOnPreBookingData = res.response[0];
      this.loadingFlag = false;
    }, error => {
      this.loadingFlag = false;
      this.messageService.showErrorMessage("Unable to retrieve data from server ");
    });
    this.bookingHistoryModalRef = this.modalService.show(this.bookingHistoryTemplate, Object.assign({}, this.config, { class: 'gray modal-lg modal-dialog-centered' }));
  }

  closeBookingHistoryModal() {
    this.bookingHistoryModalRef.hide();
  }

  selectedAppointmentDate = '';
  getSlots(apptDate) {
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = (dd.getMonth() + 1) + "";
    let monthShort = dd.toLocaleString("en-US", { month: "short" })
    let year = dd.getFullYear();
    apptDate = year + '-' + (month.length == 1 ? '0' + month : month) + '-' + (date.length == 1 ? '0' + date : date);
    this.selectedSlotDateForAppt = (date.length == 1 ? '0' + date : date) + "-" + monthShort + "-" + year;
    this.selectedAppointmentDate = apptDate;
    this.getAvailableSlots();
  }

  getAvailableSlots() {
    this.loadingFlag = true;
    let payload = {
      "Latitude": this.selectedApptDetails ? this.selectedApptDetails['latitude'] : "",
      "Longitude": this.selectedApptDetails ? this.selectedApptDetails['longitude'] : "",
      "Date": this.selectedAppointmentDate,
    }
    this.ITDoseService.getAvailableSlots(payload).subscribe((res: any) => {
      this.slotsData = res.response;
      if (this.slotsData["morning"] && this.slotsData["morning"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["morning"]);
      }
      if (this.slotsData["noon"] && this.slotsData["noon"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["noon"]);
      }
      if (this.slotsData["evening"] && this.slotsData["evening"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["evening"]);
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getSlotsOnId(event) {
    this.slotsOnTime = event;
  }

  rescheduleBtnDisable: boolean = false;
  RescheduleAppointment() {
    let payload = {
      "prebookingID": this.selectedApptDetails ? this.selectedApptDetails['VisitNo'] : "",
      "newAppDate": this.selectedSlotDateForAppt + " " + this.slotsOnTime,
      "prebookingID_Digital": this.selectedApptDetails ? this.selectedApptDetails['preBookingIdDigital'] : "",
      "RescheduleReason": this.rescheduleAppointmentForm.value ? this.rescheduleAppointmentForm.value['statusRemarks'] : "Patient Unavailable on the scheduled time",
      "AppointmentDate": this.selectedAppointmentDate,
      "AppointmentTime": this.slotsOnTime,
    }
    this.ITDoseService.RescheduleDiagnosticAppointment(payload).subscribe((res: any) => {
      if (res.isSuccess) {
        this.rescheduleBtnDisable = true;
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          "callStatusId": this.CallerStatusAutoId,
          "isOperationDone": true,
          "statusMessage": "Test Reschedule Successfully."
        });
        this.messageService.showSuccess(res['message']);
        this.closeConfirmModal();
      }
      else {
        this.rescheduleBtnDisable = false;
        this.messageService.showErrorMessage("Reschedule Appointment Failure...!");
      }
    })

  }

  statusRemarks: any;
  cancelBtnDisable: boolean = false;
  CancelAppointment() {
    let payload = {
      "prebookingID": this.selectedApptDetails ? this.selectedApptDetails['VisitNo'] : "",
      "cancelRemarks": this.statusRemarks,
      "preBookingID_Primary": "",
      "cancelAllUHIDs": "",
      "prebookingID_Digital": this.selectedApptDetails ? this.selectedApptDetails['preBookingIdDigital'] : "",
      "patient_ID": this.patientUHID,
    }
    this.ITDoseService.CancelDiagnosticAppointment(payload).subscribe((res: any) => {
      if (res.isSuccess) {
        this.cancelBtnDisable = true;
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          "callStatusId": this.CallerStatusAutoId,
          "isOperationDone": true,
          "statusMessage": "Test Cancelled Successfully."
        });
        this.messageService.showSuccess(res['message']);
        this.closeConfirmModal();
      }
      else {
        this.cancelBtnDisable = false;
        this.messageService.showErrorMessage("Cancel Appointment Failure..!");
      }
    })
  }
}
